export enum UserFollowedDataSubjectUrl {
  base = '/user-followed-data-subject{/id}{?page,size,sort*,dataSubject}',
}
